export default __webpack_public_path__ + "static/media/power-bi-icon.954962e6.png";